import { useState } from "react";
import axios from "axios";

interface UseSendToBubbleParams {
    session: string;
    base64: string;
    encrypted: string;
    type: string
}

export const useSendToBubble = (endpoint: string) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [response, setResponse] = useState<any>(null);

    const sendToBubble = async (params: UseSendToBubbleParams) => {
        setIsLoading(true);
        setError(null);

        axios.post(endpoint, params).then((response) => {
                setResponse(response.data);
            }).catch(e => setError(e.message || "An error occurred")).finally(() => setIsLoading(false));
    };

    return { sendToBubble, isLoading, error, response };
};